import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TopBarService } from 'src/app/top-bar/top-bar.service';

@Component({
  selector: 'restoreid-access-denied',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './access-denied.component.html',
  styleUrl: './access-denied.component.scss'
})
export class AccessDeniedComponent {
  public dashboardUrl = '/dashboard';
  constructor(
    private _topBarService: TopBarService,
  )
  {
    this._topBarService.setTitle('Access Denied');
  }
}
